export default __webpack_public_path__ + "static/media/service.e6d0288f.svg";